import defaultTheme from './defaultTheme'
import main from './Main'
import portal from './Portal'

const themes = { defaultTheme, main, portal }

export default themes
